import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import { ROUTES } from '../../../../../../routes/routes';

type UpdateControllerDialogProps = {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  handleSaveControllerMemoryForInstallationId: () => void;
};

export const UpdateControllerDialog: React.FC<UpdateControllerDialogProps> = ({
  showDialog,
  setShowDialog,
  handleSaveControllerMemoryForInstallationId,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('installation');

  const handleClose = () => {
    handleSaveControllerMemoryForInstallationId();
    setShowDialog(false);
  };

  const handleAction = () => {
    handleClose();
    navigate(`${ROUTES.ExalusControllerSettings()}?view=updates`);
  };

  return (
    <DialogConfirmation
      show={showDialog}
      setShow={handleClose}
      header={t('exalus.updateControllerInfo.header')}
      content={t('exalus.updateControllerInfo.content')}
      primaryBtnText={t('exalus.updateControllerInfo.update')}
      secondaryBtnText={t('exalus.updateControllerInfo.skip')}
      primaryBtnAction={handleAction}
      secondaryBtnAction={handleClose}
      timerCancel
    />
  );
};
